var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainBox"},[_c('div',{staticClass:"d_title"},[_c('el-button',{attrs:{"icon":"el-icon-refresh","size":"medium"},on:{"click":_vm.getData}},[_vm._v("刷新")])],1),_c('div',{staticClass:"mainCt"},[_vm._v(" dashboard ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }